import React from 'react';
import { Button } from '@forge/common';
import { useTranslation } from 'react-i18next';

export interface ActivityFilterFooterProps {
  isLoading: boolean;
  error: string | null;
  onReset: () => void;
  onApply: () => void;
}

const ActivityFilterFooter: React.FC<ActivityFilterFooterProps> = React.memo(({ isLoading, error, onReset, onApply }) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-gap-2">
      <Button variant="secondary" disabled={isLoading || !!error} onClick={onReset}>
        {t('activityLogFilterReset')}
      </Button>
      <Button variant="primary" disabled={isLoading || !!error} onClick={onApply}>
        {t('activityLogFilterApply')}
      </Button>
    </div>
  );
});

export default ActivityFilterFooter;
